import React from "react";
import "./Section3.css";
import Section3Image from "../../../../../assets/images/itin-sec3img1.png";
import Section3Dots from "../../../../../assets/images/aboutus-dots.png";
const Section3 = () => {
  return (
    <div className="fbarsrsrc3_section">
      <img src={Section3Dots} alt="" className="fbarsrsrc3__section_dots" />
      <div className="fbarsrsrc3__section_left">
        <img src={Section3Image} alt="" className="fbarsrsrc3__section_img" />
      </div>
      <div className="fbarsrsrc3__section_right">
        <div className="fbarsrsrc3__secleft_heading ">Late FBAR Penalties</div>
        <div className="fbarsrsrc3__secleft_description">
          <p>
            A non-willful failure to report foreign bank accounts can result in
            a penalty of up to $10,000 per account per year, an amount subject
            to annual inflation. The IRS has stated that these penalties
            represent maximum amounts and lower penalties may be appropriate
            depending on the circumstances.
          </p>
          <p>
            A willful failure to file may be subject to civil penalties equal to
            the greater of $100,000 (also subject to inflation) or 50% of the
            balance in each unreported account. In addition, criminal penalties
            of up to $250,000 or 5 years in jail (or both) may apply in the case
            of willful conduct.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section3;
